import {BigDecimal, ConfiguracionesEmpresa, Docs, logisticaManifiestoDetalleEstado, LogisticaTiposFormaPago, TiposPago, CobroDTO} from "@pcgerente-node/pcg-comun";
import {logistica_GUIA, logistica_GUIA_FOTO} from "@pcgerente-node/pcg-comun/dist/DTOs";
import {ArchivoImagen, CEL, coordenadas, ReduxHelper} from "../../../Utils/funciones";
import axios, {AxiosResponse} from "axios";
import {baseURL, headers} from "../../../redux/helpersRedux";
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import {esRetencion} from "../../../Utils/regex";

export default class ServiceDetallesLiquidacionRutaDetalles {
    /**Valida el contenido de la Guia local antes de Guardar, arroja un Error si se encontraron errores */
    private static async validarGuia(guia: logistica_GUIA, cobros: CobroDTO[], fotosCargadas: ArchivoImagen[]): Promise<boolean> {
        let msgError = ""
        const cantidadMinimaFotos = await CEL<number>(ConfiguracionesEmpresa.logistica_entrega_minimo_numero_fotos)
        const cantidadMaximaFotos = await CEL<number>(ConfiguracionesEmpresa.logistica_entrega_maximo_numero_fotos)
        
        const cobrosTotalesGuia = this.CalcularTotalCobros(cobros);
        const saldoPorPagarGuia = new BigDecimal(guia.FACTURA?.saldoPorPagar??0);
        const esGuiaFleteAlCobro = guia.tipo === LogisticaTiposFormaPago.FleteCobro;
        const cuadraCobrosFactura =  saldoPorPagarGuia.toFixed(2) === cobrosTotalesGuia.toFixed(2);

        if (guia.entregada && !guia.personaEntrega){
            msgError = "Si la guía ha sido entregada, debe indicar a quién se realizó la entrega"
        }else if(!guia.entregada && !guia.idMotivoDevolucion){
            msgError = 'Si la guía no fue entregada debe específicar un motivo de devolución'
        }else if (guia.logistica_GUIA_FOTOS && (fotosCargadas.length < cantidadMinimaFotos || fotosCargadas.length > cantidadMaximaFotos)) {
            msgError = `La guia debe tener entre ${cantidadMinimaFotos} y ${cantidadMaximaFotos} fotos`
        }else if (esGuiaFleteAlCobro && guia.entregada && !cuadraCobrosFactura) {
            msgError = "En fletes al cobro se debe justificar todo el valor por cobrar"
        } else if (esGuiaFleteAlCobro && !guia.entregada && cobrosTotalesGuia.greaterThan(0)){
            msgError = "Si la Guia/Factura no es entregada, no debe existir pago alguno"
        }

        if (msgError) 
            throw new Error(msgError);
        
        return true
    }

    static PermiteAgregarCobro(guia: logistica_GUIA): boolean {
        return guia.tipo === LogisticaTiposFormaPago.FleteCobro && new BigDecimal(guia.saldoPorPagar??0).greaterThan(0)
    }

    static ObtenerSaldoPorPagar(guia: logistica_GUIA, cobros: CobroDTO[]): BigDecimal {

        const totalCobros = cobros.reduce(
            (acc, cobro) => {
                return acc.plus(cobro.monto)
            }, new BigDecimal(0));

        return new BigDecimal(guia.saldoPorPagar??0).minus(totalCobros);
    }

    /**Intenta guardar los cambios realizados, si falla deshace todos los cambios realizados */
    static async Guardar(guia: logistica_GUIA, fotos: ArchivoImagen[], coordenadas: coordenadas, cobros: CobroDTO[], uuidManifiestoDetalle: string): Promise<string> {
        let fotosSubidas: logistica_GUIA_FOTO[] = [];
        try {
            if (await this.validarGuia(guia, cobros, fotos)) {
                //Subir las fotos nuevas
                fotosSubidas = await this.subirFotosGuia(guia.id!!, fotos)

                //Quitar las relaciones del payload para evitar actualizaciones no deseadas
                const body = {
                    idUsuario: ReduxHelper.IdUsuario(),
                    guia: {
                        ...guia,
                        latitud: coordenadas?.latitud,
                        longitud: coordenadas?.longitud,
                    } as logistica_GUIA,
                    cobros,
                    uuidManifiestoDetalle
                }

                const response = await axios.post(`${baseURL}logistica_GUIA/EnRuta/${guia.id}/liquidar`, body, headers)
                    .then((el: AxiosResponse<IApiResponse<logistica_GUIA>>) => el.data)
                if (response.error) {
                    return response.error
                }
                return ""
            }
        } catch (error) {
            //Si hubo un error al guardar, eliminar las fotos que se hayan subido de forma asincrona
            for(const foto of fotosSubidas){
                this.eliminarFotosGuia([foto]).catch((err: Error) => {console.log(err)});
            }

            if (error instanceof Error) {
                return  error.message;
            }
            return "Error desconocido";
        }
        return "Error desconocido";
    }

    /**Elimina la imagen de la UI */
    static EliminarImagen(urlImagen: string, fotos: ArchivoImagen[], setFotos: (props: ArchivoImagen[]) => void) {
        const archivosFiltrados = fotos?.filter(x => x.urlLocal !== urlImagen) || null
        setFotos(archivosFiltrados)
    }

    /**Agrega imagenes a la UI */
    static handleImagenes(
        files: FileList|null,
        fotos: ArchivoImagen[],
        setFotos: (props: ArchivoImagen[]) => void,
    ) {
        if (files) {
            let archivosLocales: ArchivoImagen[] = [];

            for (let i = 0; i < files.length; i++) {
                const urlLocalImagen = URL.createObjectURL(files[i]);
                const archivo = new ArchivoImagen(files[i], urlLocalImagen);
                archivosLocales.push(archivo);
            }

            // Concatenar las nuevas fotos con las existentes
            setFotos([...fotos, ...archivosLocales]);

        }
    }
    /**Agrega o actualiza un cobro en la UI y recalcula el saldo y cobros totales*/
    static agregarCobro(nuevoCobro: CobroDTO, cobros: CobroDTO[], setCobros: (props: any) => void) {
        const cobroFormaPagoExistente = cobros.find(c => c.idFormaPago === nuevoCobro.idFormaPago);

        if(cobroFormaPagoExistente){
            // Actualiza el monto del cobro existente sumando el nuevo monto
            const nuevoMonto = cobroFormaPagoExistente.monto.plus(nuevoCobro.monto);
            const cobrosActualizados = cobros.map(_cobro =>
                _cobro.idFormaPago === nuevoCobro.idFormaPago ?
                    { ..._cobro,
                        // Suma el monto nuevo al existente
                        monto: nuevoMonto,
                        montoStr: nuevoMonto.toFixed(2),
                        observacion: nuevoCobro.observacion
                    }
                : _cobro
            );
            setCobros(cobrosActualizados);
        } else{
            setCobros([...cobros, nuevoCobro]);
        }
    }

    /**Retorna un mensaje de error si no se pasaron todas las validaciones*/
    static validarCobro(nuevoCobro: CobroDTO, saldoPendiente: BigDecimal): string {
        let retorno = ""
        if (!nuevoCobro.FORMAPAGO) {
            retorno = "No se ha elegido una forma de pago"
        } else if (isNaN(Number(nuevoCobro.montoStr))) {
            retorno = "El monto ingresado no es válido"
        } else if (new BigDecimal(nuevoCobro.montoStr).greaterThan(saldoPendiente)) {
            retorno = "El monto a registrado no puede ser mayor que el saldo pendiente"
        } else if (nuevoCobro.monto.lessThanOrEqualTo(0)) {
            retorno = "El monto debe ser mayor a 0"
        }

        if (nuevoCobro.FORMAPAGO?.TIPO_FORMA_PAGO?.idTipoPago === TiposPago.CHEQUE) {
            if (!nuevoCobro.numeroCheque) {
                retorno = "Si la forma de pago es cheque es necesario ingresar un numero de cheque"
            } else if (!nuevoCobro.fechaCheque) {
                retorno = "Ingrese una fecha para el cheque"
            } else if (! nuevoCobro.numeroCuenta) {
                retorno = "Ingrese el numero de cuenta"
            } else if (! nuevoCobro.entidadFinanciera) {
                retorno = "Debe escribir la entidad financiera"
            }
        } else if (nuevoCobro.FORMAPAGO?.TIPO_FORMA_PAGO?.idTipoPago === TiposPago.TARJETA) {
            if (!nuevoCobro.idTipoTarjeta) {
                retorno = "Si la forma de pago es tarjeta, debe seleccionar el tipo de Tarjeta."
            } else if (!nuevoCobro.idBancoTarjeta) {
                retorno = "Si la forma de pago es tarjeta de crédito, debe seleccionar el banco de la tarjeta."
            } else if (!nuevoCobro.idMarcaTarjeta) {
                retorno = "Si la forma de pago es tarjeta de crédito, debe seleccionar la marca de la Tarjeta."
            } else if (! nuevoCobro.numeroCheque) {
                retorno = "Ingrese un numero de Lote."
            }
        } else if (nuevoCobro.FORMAPAGO?.TIPO_FORMA_PAGO?.idTipoPago === TiposPago.RETENCION){
            if(! nuevoCobro.observacion){
                retorno = "Debe ingresar el número de la retención"
            } else if (!nuevoCobro.observacion || !esRetencion(nuevoCobro.observacion)) {
                retorno = "Ingrese un número de  retención válido, Ej: 001-001-1234"
            }
        } else if (nuevoCobro.FORMAPAGO?.TIPO_FORMA_PAGO?.idTipoPago === TiposPago.TRANSFERENCIA){
            if (!nuevoCobro.numeroCuenta) {
                retorno = "Si la forma de pago es transferencia es necesario ingresar un numero de cuenta"
            } else if (!nuevoCobro.fechaCheque) {
                retorno = "Ingrese la fecha de la transferencia"
            }
        }
        return retorno
    }

    /**Elimina el cobro seleccionado de la UI y actualiza el saldo*/
    static borrarCobro(cobro: CobroDTO, cobrosExistentes: CobroDTO[], setCobros: (props: any) => void) {
        const cobrosFiltrados = cobrosExistentes.filter(c => c !== cobro)
        setCobros(cobrosFiltrados)
    }

    static AgregarCobroCanExecute(guia: logistica_GUIA): boolean{
        return guia.tipo === LogisticaTiposFormaPago.FleteCobro
            && new BigDecimal(guia.saldoPorPagar??0).greaterThan(0)
            && guia.logistica_MANIFIESTO_DETALLE!!.length>0;
    }

    static CalcularSaldoPendiente(guia: logistica_GUIA, cobros: CobroDTO[]): BigDecimal {
        const saldoPorPagar = new BigDecimal(guia.saldoPorPagar ?? 0);
        const cobrosTotales = this.CalcularTotalCobros(cobros)

        return saldoPorPagar.minus(cobrosTotales);
    }

    static CalcularTotalCobros(cobros: CobroDTO[]) {
        return cobros.reduce(
            (acc, cobro) => acc.plus(cobro.monto)
            , new BigDecimal(0)
        );
    }

    static ObtenerIdCiudadDestinoManifiesto(guia: logistica_GUIA): number {
        return guia.logistica_MANIFIESTO_DETALLE!!.find(
            lmd => lmd.estado !== logisticaManifiestoDetalleEstado.Anulado
        )?.logistica_MANIFIESTO?.idCiudadDestino || 0
    }

    /**
     * Sube las fotos de entrega a Azure y las asocia a la guia
     *
     * @param guiaId
     * @param fotos
     * @private
     */
    static async subirFotosGuia(guiaId: number, fotos: ArchivoImagen[]) {
        let imagenesSubidas: logistica_GUIA_FOTO[] = []

        for(const foto of fotos){
            const data = new FormData()
            data.append('image', foto.archivo)
            const response = await axios.post(`${baseURL}logistica_GUIA/${guiaId}/logistica_GUIA_FOTO`, data, headers)
                .then((res: AxiosResponse<logistica_GUIA_FOTO>) => res)

            if (! response.data.id) {
                throw new Error("Error al subir las imágenes")
            }
            imagenesSubidas.push(response.data)
        }

        return imagenesSubidas
    }

    /**
     * ELimina las fotos subidas a Azure
     * @param imagenes
     */
    static async eliminarFotosGuia(imagenes: logistica_GUIA_FOTO[]) {
        for( const img of imagenes ){
            await axios.delete(`${baseURL}logistica_GUIA/${img.idGuia}/logistica_GUIA_FOTO/${img.id}`, headers)
        }
    }
}
